import styled from "styled-components";

export const ClientSettingsTitleWrapperDefaultBox = styled.div`
    display: flex;
    align-content: center;

    background-color: ${({ theme }) => theme.colors.backgroundDark};
    padding: 15px;

    .close-client-settings-icon {
        background-color: transparent;
        padding: 0;
        height: max-content;

        &:hover {
            background-color: transparent;
        }
    }
`